<p-toast position="top-right" key="msj"></p-toast>
<p-toast position="top-center" key="confirm" (onClose)="cancelarMensajeConfirmacion()" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center">
        <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
        <h4>{{message.summary}}</h4>
        <p>{{message.detail}}</p>
      </div>
      <div class="grid p-fluid">
        <div class="col-6">
          <button type="button" pButton (click)="cancelarMensajeConfirmacion()" label="Cancelar"
            class="p-button-secondary"></button>
        </div>
        <div class="col-6">
          <button type="button" pButton (click)="confirmarMensaje()" label="Aceptar" class="p-button-success"></button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>
<!--<p-messages></p-messages>-->
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" acceptLabel="SI" rejectLabel="NO"
  rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<p-confirmDialog [style]="{width: '50vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
  rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar"
  [rejectVisible]="false"></p-confirmDialog>

<div class="d-flex justify-content-center">
  <div class="container-fluid" style="width: 95%;">
    <div class="row mt-5">
      <div class="col-md-12">
        <div class="card card-shadow sinborde">
          <div class="card-header sinborde" style="background: none; ">
            <div class="cardicono rounded">
              <i class="pi pi-map-marker mt-3" style="font-size: 2rem; color: #fff;"></i>
            </div>
            <header style="left: 11%; top: 5%;">Gestión de
              <div style="color:#1e5a9c; display: inline;"> Folio Unico</div>
            </header>
            <div class="row d-flex justify-content-end">
                <div class="col-2">
                  <button type="button" class="btn btn-secondary w-100" (click)="revFolioUnicoOdoo();"
                    pTooltip="Sincronización TDO con Folios Unicos de Odoo" tooltipPosition="top"
                    [disabled]="btnRevOdoo">
                    Sincronización Odoo <i class="pi pi-history"></i>
                  </button>
                </div>
              </div>

          </div>
          <div class="card-content">
            <div class="row mt-3">
              <p-table #dt1 [value]="lstFolioUnico" [tableStyle]="{'min-width': '50rem'}" styleClass="p-datatable-sm"
                [scrollable]="true" scrollHeight="500px" responsiveLayout="scroll" [globalFilterFields]="['clave_ruta','desc_ruta','ciudad']" 
                [paginator]="true" [rows]="50"
                [rowsPerPageOptions]="[25,50,75,100,150]" [showCurrentPageReport]="true" [resizableColumns]="false"
                currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros" [loading]="loading"
                sortField="desc_ciudad">
                <ng-template pTemplate="caption">
                  <div class="row">
                    <div class="flex justify-content-between align-items-center w-150">
                      <div class="row d-flex justify-content-end align-items-center  col-md-10">

                        <!-- <div class="col-md-2">
                          <p-columnFilter field="id_ciudad" matchMode="equals" [showMenu]="false">
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                              <p-dropdown [ngModel]="value" [options]="lstCiudades" optionLabel="nombre"
                                optionValue="id" (onChange)="filter($event.value)" placeholder="Filtrar ciudad"
                                [showClear]="true">
                              </p-dropdown>
                            </ng-template>
                          </p-columnFilter>
                        </div> -->
                        <div class="col-md-2 d-flex justify-content-end">
                          <span class="p-input-icon-left p-ml-auto">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" size="35" (input)="applyFilterGlobal($event, 'contains')"
                              placeholder="Buscar" class="form-control" />
                          </span>
                        </div>
                        <div class="col-md-2 d-flex justify-content-end">
                            <button type="button" pButton pRipple class="p-button-success " pTooltip="Exportar Catalogo a EXCEL"
                              tooltipPosition="right" (click)="ExportarExcel()">
                              <i class="pi pi-file-excel">Exportar</i>
                            </button>
                          </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th class="text-left" pSortableColumn="clave_ruta">Clave Ruta<p-sortIcon
                        field="clave_ruta"></p-sortIcon> </th>
                    <th class="text-left" pSortableColumn="desc_ruta" style="max-width: 200px;">Nombre de Ruta<p-sortIcon
                        field="desc_ruta"></p-sortIcon></th>
                    <th class="text-left"  pSortableColumn="ciudad">Ciudad<p-sortIcon field="ciudad"></p-sortIcon></th>
                    <th class="text-center">Kilometros</th>
                    <th class="text-center" pSortableColumn="num_folio_proyecto">Folio de Ruta<p-sortIcon
                        field="num_folio_proyecto"></p-sortIcon> </th>
                        <th class="text-center" pSortableColumn="estatus_ruta">Estatus<p-sortIcon
                            field="estatus_ruta"></p-sortIcon> </th>
                    <th style="width: 150px;"></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-data>
                  <tr>
                    <td class="text-left" style="color: #1e5a9c;"><b>{{data.clave_ruta}}</b> </td>
                    <td class="text-left" style="max-width: 200px;">{{data.desc_ruta}}</td>
                    <td class="text-left">{{data.ciudad}}</td>
                    <td class="text-center color-sombreado">{{data.num_kilometros}}</td>
                    <td class="text-center">{{data.num_folio_proyecto}}</td>
                    <td class="text-center">{{data.estatus_ruta===0?'Inactivo':'Activo'}}</td>
                    <td style="width: 150px;">
                      <div class="d-flex justify-content-around">
                        <button pButton pRipple class="custom-buttoncargar" icon="pi pi-plus" 
                          [disabled]="data.num_folio_proyecto.length!=0"
                          (click)="mostrarModalAgregarFolio(data);" 
                          pTooltip="{{ data.num_folio_proyecto.length!=0 ? 'Agregar Folio - Tiene Folio' : 'Agregar Folio' }} ">
                        </button>
                        <button pButton pRipple class="custom-buttoneditar" icon="pi pi-file-edit" 
                        [disabled]="data.num_folio_proyecto.length==0"
                        (click)="mostrarModalEditarFolio(data);" pTooltip="Editar folio"></button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--AGREGAR DE FOLIOS DE PROYECTO POR RUTA-->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dsbAgregarfolio"
      [style]="{width: '50vw','height':'550px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarModalAgregarFolio()">
      <ng-template pTemplate="header">
        Agregar Folio de Proyecto Unico
      </ng-template>
      <ng-template pTemplate="content">
        <div class="mt-5">
          <div class="row">
            <div class="col-md-12">
              <p class="d-flex align-items-center texto-valido">Ruta: &nbsp;{{this.dataAgregarFolio.desc_ruta}}</p>
            </div>
          </div>
          <form [formGroup]="foliosForm" (ngSubmit)="guardarInformacionFolio()">
            <span class="title-light mt-3">Información del Folio<i class="pi pi-cog" style="size: 2rem;"></i>
            </span>
            <div class="row mt-3">
              <div class="form-group col-md-6">
                <div class="row g-0">
                  <div class="col-sm-6 d-flex align-items-center">
                    <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 1.5rem"></i>
                      <p class="ml-1 color-icon d-inline">Folio del Proyecto</p>
                    </span>
                  </div>
                  <div class="col-sm-6">
                    <input type="string" class="form-control sinborde" pTooltip="Folio" tooltipPosition="top"
                      formControlName="num_folio_proyecto" style="text-transform:uppercase;">
                    <hr class="my-0">
                  </div>
                </div>
              </div>
            </div>
            <div class="row d-flex justify-content-center mt-5">
              <div class="col-4">
                <p *ngIf="!foliosForm.valid" class="texto-invalido text-right">
                  <i class="pi pi-info-circle" style="font-size: 1rem;">Es Necesario
                    Proporcionar La Informaci&oacute;n Obligatoria(*)</i>
                </p>
                <p *ngIf="foliosForm.valid" class="texto-valido text-right">
                  <i class="pi pi-check-circle" style="font-size: 1rem;">Informaci&oacute;n
                    Completa</i>
                </p>
              </div>
              <div class="col-2">
                <button type="submit" class="btn btn-success w-100"
                  [disabled]="!foliosForm.valid">
                  <span class="text-white">Aceptar</span>
                  <i class="pi pi-save text-white"></i>
                </button>
              </div>
            </div>
          </form>
          <div class="row d-flex justify-content-end mb-5">
            <div class="col-md-3">

              <button pButton pRipple class="custom-warn" icon="pi pi-eraser" (click)="habilitarEdicionFolios();"
                pTooltip="Habilitar campos para actualizar Información">Habilitar Edición</button>


            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarModalAgregarFolio();"></button>
      </ng-template>
    </p-dialog>

    <!--EDITAR DE FOLIOS DE PROYECTO POR RUTA - ADMIN-->
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dsbAgregarHerramientasEditar"
      [style]="{width: '50vw','height':'550px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarModalEditarFolio()">
      <ng-template pTemplate="header">
        Editar Folio de Proyecto
      </ng-template>
      <ng-template pTemplate="content">
        <div class="mt-5">
          <div class="row">
            <div class="col-md-12">
              <p class="d-flex align-items-center texto-valido">Número económico&nbsp;{{desc_num}}</p>
            </div>
          </div>
          <form [formGroup]="foliosForm" (ngSubmit)="guardarInformacionFolioEditar()">
            <span class="title-light mt-3">Información del Folio<i class="pi pi-cog" style="size: 2rem;"></i>
            </span>
            <div class="row mt-3">
              <div class="form-group col-md-6">
                <div class="row g-0">
                  <div class="col-sm-6 d-flex align-items-center">
                    <span class="input-group-addon"> <i class="pi pi-book color-icon" style="font-size: 1.5rem"></i>
                      <p class="ml-1 color-icon d-inline">Folio del Proyecto</p>
                    </span>
                  </div>
                  <div class="col-sm-6">
                    <input type="string" class="form-control sinborde" pTooltip="Folio" tooltipPosition="top"
                      formControlName="num_folio_proyecto" style="text-transform:uppercase;">
                    <hr class="my-0">
                  </div>
                </div>
              </div>
            </div>
            <div class="row d-flex justify-content-center mt-5">
              <div class="col-4">
                <p *ngIf="!foliosForm.valid" class="texto-invalido text-right">
                  <i class="pi pi-info-circle" style="font-size: 1rem;">Es Necesario
                    Proporcionar La Informaci&oacute;n Obligatoria(*)</i>
                </p>
                <p *ngIf="foliosForm.valid" class="texto-valido text-right">
                  <i class="pi pi-check-circle" style="font-size: 1rem;">Informaci&oacute;n
                    Completa</i>
                </p>
              </div>
              <div class="col-2">
                <button type="submit" class="btn btn-success w-100"
                  [disabled]="!foliosForm.valid">
                  <span class="text-white">Aceptar</span>
                  <i class="pi pi-save text-white"></i>
                </button>
              </div>
            </div>
          </form>
          <div class="row d-flex justify-content-end mb-5">
            <div class="col-md-3">

              <button pButton pRipple class="custom-warn" icon="pi pi-eraser"
                (click)="habilitarEdicionFolios_historico();"
                pTooltip="Habilitar campos para actualizar Información">Habilitar Edición</button>

            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarModalEditarFolio();"></button>
      </ng-template>
    </p-dialog>
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspSyncroOdoo" 
  [style]="{'width':'60vw','max-height':'85vh'}"
  (onHide)="CancelSyncro()" [transitionOptions]="'0ms'" styleClass="card-shadow">
    <ng-template pTemplate="header">
      Actualización Colaboradores de ODOO
    </ng-template>
    <ng-template pTemplate="content">  
      <div class="row mt-2">
        <span class="title-light"><i class="pi pi-cog"
          style="size: 1.6rem;"></i> Información procesada:</span>  
      </div>
      <div class="row mt-3 ml-2">
        <div class="col-md-4 justify-content-center">
          <div class="input-group-addon">
            <span class="align-self-start title-light">
              <i class="pi pi-users color-icon" style="font-size: 2rem"></i>
            Total de registros procesados:</span>
          </div>
          <div class="text-subMenu">
            <input type="number" pInputText
              value="{{messageColabOdoo.totalReg}}" autoWidth="false" 
              [style]="{'width':'100%'}" [disabled]="true">
          </div>
        </div>
        <div class="col-md-4 justify-content-center">
          <div class="input-group-addon">
            <span class="align-self-start title-light">
              <i class="pi pi-user-plus color-icon" style="font-size: 2rem"></i>
            Agregados en TDO:</span>
          </div>
          <div class="text-subMenu">
            <input type="number" pInputText
              value="{{messageColabOdoo.addedReg}}" autoWidth="false" 
              [style]="{'width':'100%'}" [disabled]="true">
          </div>
        </div>
        <div class="col-md-4 justify-content-center">
          <div class="input-group-addon">
            <span class="align-self-start title-light">
              <i class="pi pi-user-edit color-icon" style="font-size: 2rem"></i>
            Actualizados en TDO:</span>
          </div>
          <div class="text-subMenu">
            <input type="number" pInputText
              value="{{messageColabOdoo.updtReg}}" autoWidth="false" 
              [style]="{'width':'100%'}" [disabled]="true">
          </div>
        </div>
      </div>
      <div class="row ml-2">
        <div class="col-md-4 t-3 align-items-start" *ngIf="messageColabOdoo.invalidFolios!=0">
          <div class="row mt-3">
            <p-table [value]="lstInvalidFol" [style]="{'border-radius': '30px'}" class="table-sm rounded-table"
              [scrollable]="true" scrollHeight="200px"
              responsiveLayout="scroll"
              [paginator]="true" [rows]="50" [rowsPerPageOptions]="[20,45,50,100,150]" [showCurrentPageReport]="true"
              [resizableColumns]="false" currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros"
              [loading]="loadingInvRfc" pTooltip="Colaboradores con RFC invalido" tooltipPosition="left">
              <ng-template pTemplate="caption">
                <div class="row flex justify-content-between">
                  <div class="col-sm">
                    <div class="input-group-addon">
                      <span class="ml-3 align-self-start title-light-error" style="font-size:smaller;">
                        <!-- <i class="pi pi-times-circle color-icon-error" style="font-size: 2rem"></i> -->
                      RFC Invalidos: {{lstInvalidFol.length}}</span>
                    </div>
                  </div>
                  <div class="col-sm">
                    <button type="button" pButton pRipple class="p-button-success ml-5"
                      pTooltip="Exportar RFC Invalidos Excel" tooltipPosition="right" (click)="exportFail(1)"
                      icon="pi pi-file-excel">
                      <!-- <i class="pi pi-file-excel">Exportar</i> -->
                    </button>
                  </div>
                </div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr>
                  <th class="text-center">#Codigo</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-data let-index>
                <tr>
                  <td>
                    <p class="font-weight-bold text-center title-light">{{data[0]}}</p>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <div class="col-md-4 t-3 align-items-start" *ngIf="messageColabOdoo.failAddReg!=0">
          <div class="row mt-3">
            <p-table [value]="lstFailAdd" [style]="{'border-radius': '30px'}" class="table-sm rounded-table"
              [scrollable]="true" scrollHeight="200px"
              responsiveLayout="scroll"
              [paginator]="true" [rows]="50" [rowsPerPageOptions]="[20,45,50,100,150]" [showCurrentPageReport]="true"
              [resizableColumns]="false" currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros"
              [loading]="loadingFailAdd" pTooltip="Colaboradores con Fallo al Agregar" tooltipPosition="left">
              <ng-template pTemplate="caption">
                <div class="row flex justify-content-between">
                  <div class="col-sm">
                    <div class="input-group-addon">
                      <span class="ml-3 align-self-start title-light-error" style="font-size:smaller;">
                        <!-- <i class="pi pi-times-circle color-icon-error" style="font-size: 2rem"></i> -->
                      Fallos Agregar: {{lstFailAdd.length}}</span>
                    </div>
                  </div>
                  <div class="col-sm">
                    <button type="button" pButton pRipple class="p-button-success ml-5"
                      pTooltip="Exportar Fallos al Agregar" tooltipPosition="top" (click)="exportFail(2)"
                      icon="pi pi-file-excel">
                      <!-- <i class="pi pi-file-excel">Exportar</i> -->
                    </button>
                  </div>
                </div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr>
                  <th class="text-center">#Codigo</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-data let-index>
                <tr>
                  <td>
                    <p class="font-weight-bold text-center title-light">{{data[0]}}</p>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <div class="col-md-4 t-3 align-items-start" *ngIf="messageColabOdoo.failUpdReg!=0">
          <div class="row mt-3">
            <p-table [value]="lstFailUpdt" [style]="{'border-radius': '30px'}" class="table-sm rounded-table"
              [scrollable]="true" scrollHeight="200px"
              responsiveLayout="scroll"
              [paginator]="true" [rows]="50" [rowsPerPageOptions]="[20,45,50,100,150]" [showCurrentPageReport]="true"
              [resizableColumns]="false" currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros"
              [loading]="loadingFailUpdt" pTooltip="Colaboradores con Fallo al Actualizar" tooltipPosition="left">
              <ng-template pTemplate="caption">
                <div class="row flex justify-content-between">
                  <div class="col-sm">
                    <div class="input-group-addon">
                      <span class="ml-3 align-self-start title-light-error" style="font-size:smaller;">
                        <!-- <i class="pi pi-times-circle color-icon-error" style="font-size: 2rem"></i> -->
                      Fallos Actualizar: {{lstFailUpdt.length}}</span>
                    </div>
                  </div>
                  <div class="col-sm">
                    <button type="button" pButton pRipple class="p-button-success ml-5"
                      pTooltip="Exportar Fallos al Actualizar" tooltipPosition="top" (click)="exportFail(3)"
                      icon="pi pi-file-excel">
                      <!-- <i class="pi pi-file-excel">Exportar</i> -->
                    </button>
                  </div>
                </div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr>
                  <th class="text-center">#Folio</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-data let-index>
                <tr>
                  <td>
                    <p class="font-weight-bold text-center title-light">{{data[0]}}</p>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </ng-template>
    
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancelar" icon="pi pi-times" 
      class="p-button-text" (click)="CancelSyncro();"></button>
    </ng-template>
  </p-dialog>
   </div>
</div>

